import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CascadeSequenceProperties, Feature, FeaturePropertyKey } from '@vi-iot/client';

import { GTMService } from '@services';
import { AuthStore, DevicesStore, RichDevice, InstallationDetailsStore } from '@store';

import { EditSerialNumberModalComponent } from '../../../../../shared/components/edit-serial-number-modal/edit-serial-number-modal.component';

@Component({
  selector: 'app-system-details',
  templateUrl: './system-details.component.html',
  styleUrls: ['./system-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemDetailsComponent implements OnInit, OnDestroy {
  readonly featurePropertyKey = FeaturePropertyKey;
  editSerialNumberDialogRef: MatDialogRef<EditSerialNumberModalComponent>;
  cascadeSequence$: Observable<Feature<CascadeSequenceProperties, never>>;
  isDeviceBoiler: boolean;

  @Input() device: RichDevice;

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    public authStore: AuthStore,
    public installationDetailsStore: InstallationDetailsStore,
    public devicesStore: DevicesStore,
    private dialog: MatDialog,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.devicesStore.selectedDevice$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectedDevice) => {
        this.device = this.device ? this.device : selectedDevice;
      });
  }

  openBmuSerialModal(bmuSerial: string): void {
    this.editSerialNumberDialogRef = this.dialog.open(EditSerialNumberModalComponent, {
      width: '496px',
      panelClass: 'edit-serial-number-dialog',
      disableClose: true,
      data: {
        serialNumber: bmuSerial,
      },
    });
    this.gtmService.track('onOpen', 'Open BMU serial modal', 'bmuSerialModal');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
